import { UUID } from "crypto";
import type { FeeFilters } from "@/app/api/fees/client";

export const feeKeys = {
  all: ["fees"] as const,
  lists: () => [...feeKeys.all, "list"] as const,
  list: (filters?: FeeFilters) => [...feeKeys.lists(), filters] as const,
  byReference: (referenceType: string, referenceId: UUID) =>
    [...feeKeys.all, "by-reference", referenceType, referenceId] as const,
  totalByReference: (referenceType: string, referenceId: UUID) =>
    [...feeKeys.all, "total", referenceType, referenceId] as const,
  details: () => [...feeKeys.all, "detail"] as const,
  detail: (id: UUID) => [...feeKeys.details(), id] as const,
};
